module.exports = __webpack_public_path__ + "static/media/slide2-sk.c176f6a2.webp";